import { put, takeLatest, select, call } from "redux-saga/effects";
import { getLocalization } from "student-front-commons/src/services/localizationService";
import { endFlow } from "student-front-commons/src/actions/flow";
import { getFlow, getFlowStart } from "student-front-commons/src/selectors/flow";
import localizedLabels from "../locales";
import { LOAD_LOCALIZED_LABELS_FLOW } from "consts";
import { logError } from "utils";

export default function* () {
  yield takeLatest(getFlowStart(LOAD_LOCALIZED_LABELS_FLOW), function* () {
    try {
      const flow = yield select(getFlow(LOAD_LOCALIZED_LABELS_FLOW));

      const englishLabels = yield call(getLocalization, {
        type: "KIDS",
        locale: "en",
      });
      const userLabels = yield call(getLocalization, {
        type: "KIDS",
        locale: flow.params.locale,
      });

      localizedLabels.setContent({
        en: englishLabels,
        [flow.params.locale]: userLabels,
      });
      localizedLabels.setLanguage(flow.params.locale);
    } catch (error) {
      logError({ error, flow: LOAD_LOCALIZED_LABELS_FLOW });
    } finally {
      yield put(endFlow(LOAD_LOCALIZED_LABELS_FLOW));
    }
  });
}
